(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cx-cart-panel"] && !Shopify.designMode) return;
  try {
    (() => {
  function initCart() {
    const panel = document.getElementById('cx-cart-panel');
    const configElement = document.getElementById('cx-cart-config');
    if (!panel || !configElement || panel.dataset.ready || typeof panel.showModal !== 'function') return;
    panel.dataset.ready = 'true';
    const config = JSON.parse(configElement.textContent);
    const list = panel.querySelector('[data-cx-cart-items]');
    const status = panel.querySelector('[data-cx-cart-status]');
    const footer = panel.querySelector('[data-cx-cart-footer]');
    const empty = panel.querySelector('[data-cx-cart-empty]');
    let busy = false;
    let minimumReached = false;
    let lastTrigger = null;

    let addQueue = Promise.resolve();
    const feedbackStates = new WeakMap();
    function resetFeedback(trigger) {
      const state = trigger && feedbackStates.get(trigger);
      if (!state) return;
      clearTimeout(state.timer);
      trigger.innerHTML = state.html;
      if (state.label === null) trigger.removeAttribute('aria-label');
      else trigger.setAttribute('aria-label', state.label);
      trigger.classList.remove('cx-add-success');
      feedbackStates.delete(trigger);
    }
    function addedFeedback(trigger) {
      if (!trigger) return;
      resetFeedback(trigger);
      const state = {html:trigger.innerHTML,label:trigger.getAttribute('aria-label')};
      feedbackStates.set(trigger,state);
      trigger.classList.add('cx-add-success');
      trigger.setAttribute('aria-label',config.added);
      if (trigger.classList.contains('cx-product-add')) {
        trigger.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="m7 12 3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      } else { trigger.textContent = config.added; }
      state.timer = setTimeout(() => resetFeedback(trigger),1500);
    }
    function formFeedback(form,message,error = false) {
      let feedback = form.querySelector('[data-cx-add-feedback]');
      if (!feedback) {
        feedback = document.createElement('span');
        feedback.dataset.cxAddFeedback = '';
        feedback.setAttribute('role','status');
        feedback.setAttribute('aria-live','polite');
        form.append(feedback);
      }
      feedback.className = error ? 'cx-add-feedback is-error' : 'cx-add-feedback';
      feedback.textContent = message;
    }

    function announce(message, error = false) {
      status.textContent = message;
      status.classList.toggle('is-error', error);
    }
    function open(trigger) {
      if (!panel.open) {
        lastTrigger = trigger;
        panel.showModal();
        document.documentElement.classList.add('cx-cart-open');
      }
    }
    function setBusy(value) {
      busy = value;
      list.setAttribute('aria-busy', String(value));
      panel.querySelectorAll('[data-cx-quantity], [data-cx-remove], [data-cx-quantity-input], [data-cx-cart-checkout]').forEach(e => { e.disabled = value || (e.hasAttribute('data-cx-cart-checkout') && !minimumReached); });
    }
    async function request(url, options = {}) {
      const response = await fetch(url, {credentials:'same-origin', ...options, headers:{Accept:'application/json', ...options.headers}});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.error);
      return data;
    }
    function renderCart(cart) {
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style:'currency',currency:cart.currency}).format(cents / 100);
      list.replaceChildren();
      cart.items.forEach(item => {
        const row = document.createElement('article');
        row.className = 'cx-cart-line';
        row.dataset.key = item.key;
        row.innerHTML = '<a class="cx-cart-line-image"><img width="78" height="90" alt=""></a><div class="cx-cart-line-info"><a class="cx-cart-line-title"></a><p class="cx-cart-line-variant"></p><p class="cx-cart-line-price"></p><div class="cx-cart-line-actions"><div class="cx-cart-quantity"><button type="button" data-cx-quantity="-1">−</button><input type="number" min="0" step="1" inputmode="numeric" data-cx-quantity-input><button type="button" data-cx-quantity="1">+</button></div><button type="button" class="cx-cart-remove" data-cx-remove></button></div></div>';
        row.querySelectorAll('a').forEach(a => { a.href = item.url; });
        const img = row.querySelector('img');
        if (item.featured_image?.url || item.image) { img.src = item.featured_image?.url || item.image; img.alt = item.product_title; } else { img.hidden = true; }
        row.querySelector('.cx-cart-line-title').textContent = item.product_title;
        const variant = row.querySelector('.cx-cart-line-variant');
        variant.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        variant.hidden = !variant.textContent;
        Object.entries(item.properties || {}).forEach(([name, value]) => {
          if (!value || name.startsWith('_')) return;
          const property = document.createElement('p');
          property.className = 'cx-cart-line-variant';
          property.style.overflowWrap = 'anywhere';
          property.textContent = name + ': ' + value;
          variant.after(property);
        });
        row.querySelector('.cx-cart-line-price').textContent = money(item.final_line_price);
        const input = row.querySelector('input');
        input.value = item.quantity;
        input.setAttribute('aria-label', config.quantity + ': ' + item.product_title);
        row.querySelector('[data-cx-quantity="-1"]').setAttribute('aria-label', config.less + ': ' + item.product_title);
        row.querySelector('[data-cx-quantity="1"]').setAttribute('aria-label', config.more + ': ' + item.product_title);
        const remove = row.querySelector('[data-cx-remove]');
        remove.textContent = config.remove;
        remove.setAttribute('aria-label', config.remove + ': ' + item.product_title);
        list.append(row);
      });
      empty.hidden = cart.item_count !== 0;
      list.hidden = cart.item_count === 0;
      footer.hidden = cart.item_count === 0;
      minimumReached = cart.item_count > 0 && cart.total_price >= config.minimum;
      const minimumMessage = panel.querySelector('[data-cx-cart-minimum]');
      const remaining = Math.max(0,config.minimum - cart.total_price);
      minimumMessage.textContent = config.minimumText.replace('__MINIMUM__',money(config.minimum)) + ' ' + (minimumReached ? config.reachedText : config.remainingText.replace('__AMOUNT__',money(remaining)));
      minimumMessage.classList.toggle('is-reached',minimumReached);
      panel.querySelector('[data-cx-cart-checkout]').disabled = busy || !minimumReached;
      panel.querySelector('[data-cx-cart-total]').textContent = money(cart.total_price);
      document.querySelectorAll('[data-cx-cart-count]').forEach(e => { e.textContent = cart.item_count; });
    }
    async function loadCart(trigger) {
      if (busy) return;
      open(trigger);
      setBusy(true);
      announce(config.loading);
      try { await addQueue; renderCart(await request(config.read)); announce(''); }
      catch (error) { announce(error.message || config.error, true); }
      finally { setBusy(false); }
    }
    async function changeQuantity(row, quantity, focusSelector) {
      if (busy || !Number.isSafeInteger(quantity) || quantity < 0) return;
      const key = row.dataset.key;
      setBusy(true);
      announce(config.loading);
      try {
        await addQueue;
        renderCart(await request(config.change, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})}));
        announce('');
        const replacement = [...list.children].find(e => e.dataset.key === key);
        setBusy(false);
        if (replacement && focusSelector) replacement.querySelector(focusSelector)?.focus();
      } catch (error) {
        try { renderCart(await request(config.read)); } catch (_) {}
        announce(error.message || config.error, true);
      } finally { setBusy(false); }
    }
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-cx-cart-open]');
      if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      loadCart(trigger);
    });
    document.addEventListener('submit', async event => {
      const form = event.target;
      if (form instanceof HTMLFormElement && new URL(form.action,location.href).pathname.endsWith('/cart') && event.submitter?.name === 'checkout') {
        if (form.dataset.cxMinimumApproved) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const checkoutTrigger = event.submitter;
        try {
          await addQueue;
          const currentCart = await request(config.read);
          renderCart(currentCart);
          if (minimumReached) {
            form.dataset.cxMinimumApproved = 'true';
            form.requestSubmit(checkoutTrigger);
            delete form.dataset.cxMinimumApproved;
          } else { open(checkoutTrigger); }
        } catch (error) { open(checkoutTrigger); announce(error.message || config.error,true); }
        return;
      }
      if (!(form instanceof HTMLFormElement) || !new URL(form.action, location.href).pathname.endsWith('/cart/add')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.cxAdding === 'true') return;
      const trigger = event.submitter || form.querySelector('[type="submit"]');
      if (trigger?.disabled) return;
      const data = new FormData(form);
      data.delete('return_to');
      form.dataset.cxAdding = 'true';
      resetFeedback(trigger);
      formFeedback(form,config.loading);
      if (trigger) { trigger.disabled = true; trigger.setAttribute('aria-busy','true'); }
      const operation = addQueue.then(async () => {
        try {
          await request(config.add,{method:'POST',body:data});
          addedFeedback(trigger);
          formFeedback(form,config.added);
          // The add succeeded even if refreshing the cart temporarily fails.
          try { renderCart(await request(config.read)); } catch (_) {}
        } catch (error) { formFeedback(form,error.message || config.error,true); }
        finally {
          delete form.dataset.cxAdding;
          if (trigger) { trigger.disabled = false; trigger.removeAttribute('aria-busy'); }
        }
      });
      addQueue = operation.catch(() => {});
      await operation;
    },true);
    panel.addEventListener('click', event => {
      if (event.target.closest('[data-cx-cart-close]')) { panel.close(); return; }
      const row = event.target.closest('.cx-cart-line');
      if (!row) return;
      const button = event.target.closest('[data-cx-quantity]');
      if (button) changeQuantity(row,Number(row.querySelector('input').value) + Number(button.dataset.cxQuantity),'[data-cx-quantity="' + button.dataset.cxQuantity + '"]');
      if (event.target.closest('[data-cx-remove]')) changeQuantity(row,0);
    });
    panel.addEventListener('change', event => {
      if (event.target.matches('[data-cx-quantity-input]')) changeQuantity(event.target.closest('.cx-cart-line'),Number(event.target.value),'input');
    });
    panel.addEventListener('close', () => { document.documentElement.classList.remove('cx-cart-open'); lastTrigger?.focus(); });
    panel.addEventListener('click', event => {
      if (event.target !== panel) return;
      const rect = panel.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCart); else initCart();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-dessert-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
 function initDesserts() {
  const dialog = document.getElementById('cx-dessert-dialog');
  if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
  dialog.dataset.ready = 'true';
  let trigger;
  function updateLinks() {
   const selected = [...dialog.querySelectorAll('input:checked')].map(input => input.value);
   dialog.querySelectorAll('[data-store]').forEach(link => {
    const message = dialog.dataset.message + ' ' + link.dataset.store + '.\n' + (selected.length ? dialog.dataset.selection + ' ' + selected.join(', ') + '.' : dialog.dataset.generic) + '\n' + dialog.dataset.question;
    link.href = 'https://wa.me/' + link.dataset.phone + '?text=' + encodeURIComponent(message);
   });
  }
  document.querySelectorAll('[data-cx-desserts-open]').forEach(button => button.addEventListener('click', event => {
   event.preventDefault(); trigger = button; updateLinks(); dialog.showModal();
  }));
  dialog.querySelector('[data-cx-desserts-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('change', updateLinks);
  dialog.addEventListener('close', () => trigger?.focus());
  dialog.addEventListener('click', event => {
   if (event.target !== dialog) return;
   const rect = dialog.getBoundingClientRect();
   if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDesserts); else initDesserts();
 document.addEventListener('shopify:section:load', initDesserts);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
 function initCandy() {
  const root = document.getElementById('cx');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  root.querySelectorAll('[data-cx-sort]').forEach(select => {
   const submit = select.form.querySelector('button');
   if (submit) submit.hidden = true;
   select.addEventListener('change', () => select.form.requestSubmit());
  });
  const pool = root.querySelector('#cx-hero-pool');
  if (pool) {
   const candidates = [...pool.content.querySelectorAll('a')];
   let previous = [];
   try { previous = JSON.parse(sessionStorage.getItem('cx-hero-previous') || '[]'); } catch (_) {}
   if (!Array.isArray(previous)) previous = [];
   let choices = candidates.filter(item => !previous.includes(item.getAttribute('href')));
   if (choices.length < 3) choices = candidates;
   for (let i = choices.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [choices[i], choices[j]] = [choices[j], choices[i]];
   }
   const selected = choices.slice(0, 3);
   const cards = root.querySelectorAll('.cx-hero-pack');
   const introImages = root.querySelectorAll('.cx-intro-products img');
   selected.forEach((item, i) => {
    const card = cards[i];
    if (!card) return;
    const image = item.querySelector('img').cloneNode(true);
    image.loading = 'eager';
    card.href = item.getAttribute('href');
    card.querySelector('img').replaceWith(image);
    card.querySelector('span').textContent = item.dataset.title + ' ↗';
    if (introImages[i]) {
     const introImage = image.cloneNode(true);
     introImage.alt = '';
     introImages[i].replaceWith(introImage);
    }
   });
   try { sessionStorage.setItem('cx-hero-previous', JSON.stringify(selected.map(item => item.getAttribute('href')))); } catch (_) {}
  }
  const intro = root.querySelector('.cx-intro');
  if (!intro || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try { if (sessionStorage.getItem('cx-online-intro-v2')) return; sessionStorage.setItem('cx-online-intro-v2','1'); } catch (_) {}
  intro.hidden = false;
  const close = () => { intro.hidden = true; };
  intro.querySelector('[data-skip-intro]').addEventListener('click',close);
  document.addEventListener('keydown',event => { if (event.key === 'Escape') close(); },{once:true});
  setTimeout(close,2200);
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initCandy); else initCandy();
 document.addEventListener('shopify:section:load',initCandy);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-search-index"] && !Shopify.designMode) return;
  try {
    (() => {
  function initSearch() {
    const index = document.querySelector('[data-cx-search-index]');
    const output = document.querySelector('[data-cx-product-search]');
    const native = document.querySelector('[data-cx-native-results]');
    if (!index || !output || !native || output.dataset.ready) return;
    output.dataset.ready = 'true';
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    const aliases = {snoep:'candy',snoepjes:'candy',drank:'drinks',drankjes:'drinks',drinken:'drinks',chocolade:'chocolate',koek:'cookies',koekjes:'cookies',pakketten:'box',pakket:'box',schepsnoep:'schepsnoep',chips:'chips',snack:'snacks',snacks:'snacks',boxen:'box'};
    const oneTypo = (a,b) => {
      if (a.length < 5 || b.length < 5 || a.slice(0,2) !== b.slice(0,2) || Math.abs(a.length-b.length)>1) return false;
      let i=0,j=0,errors=0;
      while(i<a.length && j<b.length) {
        if(a[i]===b[j]) {i++;j++;continue;}
        if(++errors>1) return false;
        if(a.length>b.length) i++; else if(b.length>a.length) j++; else {i++;j++;}
      }
      return errors+(i<a.length || j<b.length ? 1 : 0)<=1;
    };
    const cards = [...index.querySelectorAll('template[data-search-card]')].map((template,position)=>({
      template,position,available:template.dataset.available==='true',
      title:normalize(template.dataset.title),
      fields:[normalize(template.dataset.title),normalize(template.dataset.type),normalize(template.dataset.tags)]
    }));
    if(cards.length !== Number(index.dataset.total)) return;
    const list=output.querySelector('[data-cx-search-results]');
    const count=output.querySelector('[data-cx-search-count]');
    const empty=output.querySelector('[data-cx-search-empty]');
    const more=output.querySelector('[data-cx-search-more]');
    let matches=[],shown=0;
    function append() {
      const stop=Math.min(shown+24,matches.length);
      for(;shown<stop;shown++) list.append(matches[shown].template.content.cloneNode(true));
      more.hidden=shown>=matches.length;
    }
    function render(query) {
      const text=normalize(query);
      const tokens=text.split(' ').filter(Boolean);
      matches=cards.map(card=>{
        let score=0;
        for(const token of tokens) {
          const choices=[token,aliases[token]].filter(Boolean);
          let best=0;
          card.fields.forEach((field,fieldIndex)=>{
            const words=field.split(' ');
            choices.forEach(choice=>{
              if(fieldIndex===1 && !aliases[token] && field!==choice && field!==text) return;
              if(words.includes(choice)) best=Math.max(best,[12,5,3][fieldIndex]);
              else if(choice.length>=3 && words.some(word=>word.startsWith(choice))) best=Math.max(best,[9,4,2][fieldIndex]);
              else if(words.some(word=>oneTypo(choice,word))) best=Math.max(best,[6,2,1][fieldIndex]);
            });
          });
          if(!best) return null;
          score+=best;
        }
        if(text && card.title.includes(text)) score+=30;
        return {...card,score};
      }).filter(Boolean).sort((a,b)=>Number(b.available)-Number(a.available) || b.score-a.score || a.position-b.position);
      list.replaceChildren();shown=0;append();
      count.textContent=matches.length+' '+index.dataset.countLabel;
      empty.hidden=matches.length!==0;
      document.querySelectorAll('form[role="search"] input[name="q"]').forEach(input=>{input.value=query;});
      const heading=document.querySelector('.cx-section-heading .cx-eyebrow');
      if(heading) heading.textContent=heading.dataset.label+' '+query;
    }
    const heading=document.querySelector('.cx-section-heading .cx-eyebrow');
    if(heading) heading.dataset.label=heading.textContent.replace(new URL(location.href).searchParams.get('q') || '', '').trim();
    native.remove();output.hidden=false;
    render(new URL(location.href).searchParams.get('q') || '');
    more.addEventListener('click',()=>{const first=shown;append();list.children[first]?.querySelector('a')?.focus();});
    document.addEventListener('submit',event=>{
      const form=event.target;
      if(!(form instanceof HTMLFormElement) || !form.matches('[role="search"]')) return;
      const input=form.querySelector('input[name="q"]');
      if(!input || new URL(form.action,location.href).pathname!==location.pathname) return;
      event.preventDefault();
      const url=new URL(location.href);url.searchParams.set('q',input.value);url.searchParams.set('type','product');url.searchParams.delete('page');
      history.pushState({},'',url);render(input.value);
      output.scrollIntoView({block:'start',behavior:'instant'});
    });
    window.addEventListener('popstate',()=>render(new URL(location.href).searchParams.get('q') || ''));
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initSearch); else initSearch();
  document.addEventListener('shopify:section:load',initSearch);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cx-site-footer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-cx-cookie-preferences]');
  if (!button) return;
  const status = document.getElementById('cx-cookie-status');
  button.disabled = true;
  if (status) status.hidden = true;
  try {
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
      await new Promise(function(resolve, reject) {
        const script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.async = true;
        const timeout = setTimeout(function() { reject(new Error('timeout')); }, 12000);
        script.onload = function() { clearTimeout(timeout); resolve(); };
        script.onerror = function() { clearTimeout(timeout); reject(new Error('load')); };
        document.head.appendChild(script);
      });
    }
    await window.privacyBanner.showPreferences();
  } catch (error) {
    if (status) {
      status.textContent = status.dataset.error;
      status.hidden = false;
    }
  } finally {
    button.disabled = false;
  }
});
  } catch(e) { console.error(e); }
})();

})();
